<template>
<main class="popup-contanier">
    <div class="Meun">
        <el-dialog :visible.sync="show" @closed="$emit('closed')">
            <div v-if="defaultData.gift">
                <div class="menuimg1">
                    <div class="product-content">
                        <el-image :src="mList.Picture" :preview-src-list="srcList" fit="cover" class="product-img"></el-image>
                        <div class="content" v-if="mList.Introduction">
                            <h1>{{mList.Name}}</h1>
                            <p class="product-text price">價格： ${{mList.Price}}</p>
                            <p class="product-text" >{{mList.Introduction.title}}</p>
                            <hr style="background-color:#ff6">
                            <p class="product-text">{{mList.Introduction.paragraphOne}}</p>
                            <p class="product-text">{{mList.Introduction.paragraphSecond}}</p>
                            <div class="product-text li-content">
                                <img src="../../assets/images/jiantou.svg" style="width:20px;height:20px"/>
                                <p style="margin-left:10px">{{mList.Introduction.liOne}}</p>
                            </div>
                            <div class="product-text li-content">
                                <img src="../../assets/images/jiantou.svg" style="width:20px;height:20px"/>
                                <p style="margin-left:10px">{{mList.Introduction.liTwo}}</p>
                            </div>
                            <p class="product-text">{{mList.Introduction.paragraphThird}}</p>
                            <p class="product-text">{{mList.Introduction.paragraphFour}}</p>
                        </div>
                    </div>
                    <div class="posa1">
                        <el-button class="calla" type="success" size="small" @click="openLink(mList.Link_app)">{{ $t("message.buttons.whatsApp") }}</el-button>
                        <el-button class="calla" type="success" size="small" @click="openLink(mList.Link_online)">{{ $t("message.buttons.linkButton") }}</el-button>
                    </div>
                </div>
            </div>
            <div v-else-if="defaultData.menu_media.length !== 0">
                <div class="menuimg1">
                    <div class="posa1">
                        <el-button class="calla" type="success" size="small" @click="openLink(mList.Link_app)">{{ $t("message.buttons.whatsApp") }}</el-button>
                        <el-button class="calla" type="success" size="small" @click="openLink(mList.Link_online)">{{ $t("message.buttons.linkButton") }}</el-button>
                    </div>
                    <el-image style="flex: 0 0 80%" :src="mList.Picture" width="60%" height="100%" :preview-src-list="srcList"></el-image>
                    <div class="posa1">
                        <el-button class="calla" type="success" size="small" @click="openLink(mList.Link_app)">{{ $t("message.buttons.whatsApp") }}
                        </el-button>
                        <el-button class="calla" type="success" size="small" @click="openLink(mList.Link_online)"> {{ $t("message.buttons.linkButton") }}</el-button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-for="imgs in currentSet.medias" class="menuimg" :key="imgs.id">
                <img style="flex: 0 0 30%; border-radius: 10px" :src="imgs.picture1" width="40%" v-if="imgs.picture1"/>
                <img style="flex: 0 0 30%; border-radius: 10px" :src="imgs.picture2" width="40%" height="100%" v-if="imgs.picture2"/>
                </div>
                <div class="dialog_center" style="border-radius: 10px">
                <p style=" text-align: center; font-size: 1.3rem; font-weight: 300; margin-bottom: 1rem; color: #eb6410;">
                    {{ currentSet.name }}
                </p>
                <p style="font-size: 15px">
                    <span> <i class="el-icon-goods"></i> </span>
                    <span v-if=" currentSet.prices === 714 ? true : currentSet.prices === 722 ? true : currentSet.prices === 108 && currentSet.id === 49 ">價格：$ {{ currentSet.prices }}起 免運費</span >
                    <span v-else-if="currentSet.prices === 98 && currentSet.id === 1" >價格：$ {{ currentSet.prices }}/盤</span >
                    <span v-else>價格：$ {{ currentSet.prices }}</span>
                </p>
                <p style="font-size: 15px">
                    <span> <i class="el-icon-s-custom"></i></span>
                    <span>適合人數：{{ currentSet.compatibility }}</span>
                </p>
                <p style="font-size: 15px">
                    <span> <i class="el-icon-s-order"></i></span>
                    <span>{{ currentSet.description }}</span>
                </p>
                </div>
                <div class="dialog_bottom">
                <el-form ref="setOrderForm">
                    <el-form-item>
                    <el-collapse>
                        <el-collapse-item class="zd" v-for="(menu, menuId) in this.currentSet.menus" :key="menuId" :title="menu.name">
                        <div v-for="(item, idx) in menu.items" :key="idx">
                            <div class="fff">
                                <span>{{ item.name }}</span>
                                <span v-if="item.price" > ${{ item.price }}</span>
                                <span v-if="item.cover === ''"></span>
                                <span v-else>
                                    <img :src="item.cover" alt width="130px" height="90px"/>
                                </span>
                            </div>
                        </div>
                        </el-collapse-item>
                    </el-collapse>
                    </el-form-item>
                </el-form>
                </div>
                <div class="posa">
                <el-button class="calla" type="success" size="mini">
                    <a :href="this.currentSet.Link_app" target="_blank" style="text-decoration: none; color: #fff" >{{ $t("message.buttons.whatsApp") }}</a>
                </el-button>
                <el-button class="calla" type="success" size="mini" v-if="this.currentSet.id === 14">
                    <a href="https://cateraway.rakosell.com/zh/product/10to12happy-7247" target="_blank" style="text-decoration: none; color: #fff">{{ $t("message.buttons.linkButton") }}</a>
                </el-button>
                <el-button class="calla" type="success" size="mini" v-else>
                    <a :href="this.currentSet.Link_online" target="_blank" style="text-decoration: none; color: #fff">{{ $t("message.buttons.linkButton") }}</a>
                </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</main>
</template>

<script>
export default {
    props:{
        defaultData:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    data() {
        return {
            show:true,
            mList: {},
            srcList: [],
            currentSet: [],
        }
    },
    computed:{
        showOne() {
            return this.show && this.visibleOne
        },
        showSecond() {
            return this.show && this.visibleSecond
        }
    },
    mounted(){
        if (this.defaultData.menu_media.length !== 0) {
            this.mList = this.defaultData.menu_media[0];
            this.srcList.splice(0, 1, this.defaultData.menu_media[0].Picture);
            this.visibleOne = true;
        } else {
            this.visibleSecond = true; 
            this.currentSet = this.defaultData;
        }
    },
    methods:{
        openLink(link, data) {
            window.open(link, "_blank");
            // this.$router.push({ name: "proDetails", query: { name: data.name } });
        },
    }
}
</script>

<style lang="less" scoped>
.popup-contanier{
    .Meun {
        /deep/ .el-dialog{
            margin-top: 10vh !important;
            width: 60%;
            & .el-dialog__body {
                padding: 10px 10px;
            }
        }
        .menuimg, .menuimg1 {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
        }
        .menuimg1 {
            height: 100%;
            .product-content{
                display: flex;
                flex-wrap:wrap ;
                justify-content: center;
                width: 90%;
                .product-img{
                    flex: 0 0 50%;
                    @media all and (max-width: 900px) {
                        flex:0 0 100%;
                        max-width: 300px;
                    }
                    @media all and (max-width: 768px) {
                        flex:0 0 100%;
                        max-width: 200px;
                    }
                }
                .content{
                    box-sizing: border-box;
                    flex: 1;
                    max-width: 400px;
                    padding-left: 50px;
                    @media all and (max-width: 900px) {
                        flex:0 0 100%;
                        max-width: 100%;
                        margin: 20px 0;
                        padding-left: 50px;
                    }
                    @media all and (max-width: 768px) {
                        padding-left: 0px;
                    }
                    .price{
                        font-size: 20px !important;
                        color: #eb6410 !important;
                    }
                    .li-content{
                        display: flex;
                        margin: 5px 0 !important;
                    }
                    .product-text{
                        font-size: 14px;
                        color: #95989d;
                        margin: 15px 0;
                    }
                }
            }
        }
        .posa1, .posa {
            display: flex;
            justify-content: center;
            align-items: center;
            /* margin-top: 4%; */
            margin: 2% 0;
            flex: 0 0 80%;
        }
        .posa1 .el-button--success,
        .posa .el-button--success {
            background-color: #eb6410;
            border-color: #eb6410;
            margin: 0 3%;
        }
        .posa1 .el-button--success {
            flex: 0 0 47%;
        }
    }
}
@media (max-width: 1255px) {
    .popup-contanier{
        .Meun{
            /deep/ .el-dialog{
                width: 85%;
            }
        }
    }
}
@media (max-width: 768px) {
    .popup-contanier{
        .Meun {
            /deep/ .el-dialog{
                width: 90%;
            }
        }
    }
}
@media (max-width: 480px) {
    .popup-contanier{
        
        .Meun  {
            ::v-deep .el-dialog{
                width: 100%;
            }
            .menuimg {
                height: 130px;
            }
            .menuimg1 {
                height: 100%;
            }
        }
    }
}
</style>
